import {Route} from "react-router-dom";
import {lazy} from "react";
import UrlsConfig from "@/config/UrlsConfig";

const RegisterNewPartner = lazy(() => import("@/pages/ControlPanel/Nested/RegisterNewPartner/RegisterNewPartner"));
const EditPartner = lazy(() => import("@/pages/ControlPanel/Nested/EditPartner/EditPartner"));
const PartnerProfileView = lazy(() => import("@/pages/ControlPanel/Nested/PartnerProfile/PartnerProfileView"));

const urlsConfig = new UrlsConfig();

export function partnersRoutes() {
    return (
      <>
          <Route path={urlsConfig.registerNewPartner.to} element={<RegisterNewPartner/>}/>
          <Route path={`${urlsConfig.editPartner.to}/:partnerId`} element={<EditPartner/>}/>
          <Route path={`${urlsConfig.partnerProfile.to}/:partnerId`} element={<PartnerProfileView/>}/>
      </>
    );
}
